import {objectsPagination} from "@/services/pagination";
import {
  changeStatus,
  exportSnapshot,
  getStatus,
  listObjectEntryDetails,
  listObjects,
  protectAll,
  unprotectAll
} from "@/services/api/app/office/entraId/seats"

const defaultState = () => ({
  objects: [],
  pagination: {
    ...objectsPagination
  },
  entryDetails: [],
  search: null,
  filter: {
    statuses: null,
  },
  displayName: null,
  status: null
})

export default {
  namespaced: true,
  actions: {
    list({ commit, state }) {
      return listObjects({
        pagination: state.pagination,
        filter: state.filter,
        backupAction: state.filter.statuses,
        objectType: state.displayName,
        searchTerm: state.search
      })
        .then(({ result, pagination }) => {
          commit('setObjects', result);
          commit('setPagination', pagination);
        })
        .catch(error => {
          console.error("Failed to list objects:", error);
          throw error;
        });
    },
    getStatus({commit}) {
      return getStatus()
        .then(result => {
          commit('setStatus', result)
        })
    },
    listObjectEntryDetails({ commit }, { id }) {
      return listObjectEntryDetails({ id })
        .then(res => {
          commit('setEntryDetails', res);
          return res;
        })
    },
    changeStatus({commit}, data) {
      return changeStatus(data)
    },
    protectAll() {
      return protectAll();
    },
    unprotectAll() {
      return unprotectAll();
    },
    exportSnapshot({commit, state}, {objectType, backupAction, searchTerm, pagination}) {
      return exportSnapshot(objectType, backupAction, searchTerm, pagination)
    },
  },
  mutations: {
    setObjects(state, objects) {
      state.objects = objects;
    },
    setEntryDetails(state, payload) {
      state.entryDetails = payload;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = { ...objectsPagination };
    },
    setSearch(state, searchTerm) {
      state.search = searchTerm;
    },
    setFilter(state, filter) {
      state.filter = filter;
    },
    setStatuses(state, statuses) {
      state.statuses = statuses;
    },
    setDisplayName(state, displayName) {
      state.displayName = displayName;
    },
    setStatus(state, status) {
      state.status = status
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },

  state: defaultState()
}
